import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, {
  IFilter,
  IHttpResponse,
  IUri,
  buildUrl,
} from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'events';

interface IGetGroupEventList extends Omit<IUri, 'resource'> {
  token?: string | null;
  filters: IFilter[];
  sort?: string[];
}
interface IGetGroupEventListResponse extends IHttpResponse {
  body?: {
    _embedded?: {
      events?: IGroupEvent[] | undefined;
    };
    count?: number;
  };
}
export default async ({
  token,
  filters,
  pages,
  sort,
  ...buildUrlProps
}: IGetGroupEventList): Promise<IGetGroupEventListResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: filters,
    pages: pages,
    sorts: sort,
    resource: RESOURCE,
    ...buildUrlProps,
  });
  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    token: token ? token : guestToken,
    skipTimestamp: true,
  });
};
